import { useEffect, useState, useContext } from "react";
import { UserContext } from "../context/UserContext";
import api from "../api";


export default function AdminPermissions() {
  const [roles, setRoles] = useState([]);


  const [permissions, setPermissions] = useState([]);
  const [rolePerms, setRolePerms] = useState({});
  const [loading, setLoading] = useState(false);
  const { user } = useContext(UserContext);

  useEffect(() => {
    api.get("/roles").then(res => {
      const sorted = [...res.data].sort((a,b) => a.order-b.order);
      setRoles(sorted);
      sorted.forEach(role => {
        api.get(`/permissions/role/${role.name}`).then(res2 => {
          setRolePerms(rp => ({ ...rp, [role.name]: res2.data }));
        });
      });
    });
    api.get("/permissions").then(res => setPermissions(res.data));
  }, []);

  const handleChange = (role, permId, checked) => {
    const updated = checked
      ? [...(rolePerms[role] || []), permId]
      : (rolePerms[role] || []).filter(id => id !== permId);
    setRolePerms(rp => ({ ...rp, [role]: updated }));
  };

  const saveRolePerms = async (role) => {
    setLoading(true);
    await api.post(`/permissions/role/${role}`, { permissionIds: rolePerms[role] });
    setLoading(false);
    alert("Rechte gespeichert");
  };

  return (
    <div className="home-page">
  <section style={{width:'100vw', margin:0, padding:0, position:'relative', left:'-120px'}}>
        <h2 className="hero-title" style={{ textAlign:'center', margin:'0 0 8px' }}>Rechteverwaltung</h2>
        <p className="hero-desc" style={{ margin:'0 auto 24px', textAlign:'center', maxWidth:760 }}>Verwalte die Rechte für jede Rolle. Änderungen werden sofort gespeichert.</p>
      </section>
  <section style={{width:'100%',margin:0,padding:0}}>
        <table style={{width:'100%', borderCollapse:'collapse'}}>
          <thead>
            <tr>
              <th>Recht</th>
              <th>Beschreibung</th>
              {roles.map(role => <th key={role.name}>{role.label}</th>)}
            </tr>
          </thead>
          <tbody>
            {permissions.map(perm => (
              <tr key={perm.id}>
                <td>{perm.name}</td>
                <td>{perm.description}</td>
                {roles.map(role => {
                  const userMax = Math.max(...(user?.roles||[]).map(r => roles.findIndex(rr => rr.name === r)));
                  const roleIdx = roles.findIndex(rr => rr.name === role.name);
                  const disabled = loading || roleIdx > userMax;
                  return (
                    <td key={role.name} style={{textAlign:'center'}}>
                      <input
                        type="checkbox"
                        checked={rolePerms[role.name]?.includes(perm.id) || false}
                        onChange={e => handleChange(role.name, perm.id, e.target.checked)}
                        disabled={disabled}
                      />
                    </td>
                  );
                })}
              </tr>
            ))}
          </tbody>
        </table>
        <div style={{marginTop:24}}>
          <button className="hero-btn-primary" onClick={async () => {
            setLoading(true);
            await Promise.all(
              roles.map(role => api.post(`/permissions/role/${role.name}`, { permissionIds: rolePerms[role.name] }))
            );
            setLoading(false);
            alert("Alle Rechte gespeichert");
          }} disabled={loading}>
            Alle Rechte speichern
          </button>
        </div>
      </section>
    </div>
  );
}
